import styled from "styled-components"

import {twoPxElevation} from "@irati/ui/src/global/elevation"

interface PartialProps {
  size: number,
  alignLeft?: boolean,
  backgroundColor?: string,
  noBorderRadius?: boolean
}

interface Props extends PartialProps {
  border: number
}

export const StyledImage = styled.img<PartialProps>`
  ${({size, noBorderRadius}) => `
    width: ${size}px;
    height: ${size}px;
    border-radius: ${noBorderRadius ? "unset" : `${size}px`};
  `}
`

export const ImageContainer = styled.div<PartialProps>`
  display: flex;
  justify-content: center;
  width: 100%;

  ${({size}) => `
    height: ${size / 2 - 5}px;
  `}
`

// We need this as we need to absolute the inner and flex box doesn't like it
export const OuterContainer = styled.div<PartialProps>`
  ${({size}) => `
    width: ${size}px;
  `}
`

export const ImageBorder = styled.div<Props>`
  position: absolute;

  ${({size, border, alignLeft, theme, backgroundColor}) => `
    background-color: ${backgroundColor || "white"};
    top: -${size / 2 + 5}px;
    width: ${size}px;
    height: ${size}px;
    border-radius: ${size}px;
    padding: ${border / 2}px;
    ${alignLeft ? `left: ${theme.spacing.five};` : ""}
  `}
`

export const ProfileContainer = styled.div<PartialProps>`
  display: flex;
  justify-content: center;
  width: 100%;

  ${({size}) => `
    height: ${size / 2 - 5}px;
  `}
`

export const ProfileBorder = styled.div<Props>`
  position: absolute;
  background-color: white;
  ${twoPxElevation}

  ${({size, border}) => `
    top: -${size / 2 + 5}px;
    width: ${size}px;
    height: ${size}px;
    border-radius: ${size}px;
    padding: ${border / 2}px;
  `}
`
